import React from "react";
import { useLocation } from "react-router-dom";

const MainContent = ({ children }) => {
  const location = useLocation();

  if (location.pathname === "/login" || location.pathname === "/signup") {
    // This is now redundant due to the new routing structure, 
    // but we can leave it or remove it. I'll remove it to ensure content visibility.
  }

  return (
    <main
      className="relative min-h-screen pt-20 overflow-x-hidden"
      style={{ backgroundColor: "transparent" }}
    >
      <div className="transition-all duration-300 ease-out">
        <div className="page-container pb-8">
          {children}
        </div>
      </div>
    </main>
  );
};

export default MainContent;
